import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { PopupProvider } from "@/contexts/PopupContext";
import ScrollToTop from "@/components/layout/ScrollToTop";
import Header from "@/components/layout/Header";
import PPCLpHeader from "@/components/layout/PPCLpHeader";
import TopBar from "@/components/layout/TopBar";
import Footer from "@/components/layout/Footer";
import MetaFooter from "@/components/layout/MetaFooter";
import HomePage from "@/pages/HomePage";
import PPCLandingPage from "@/pages/PPCLandingPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import ServicePage from "@/pages/ServicePage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import ApplicationPage from "@/pages/ApplicationPage";

function Layout() {
  const location = useLocation();
  const isPpcLp = location.pathname === '/ppc-lp';
  const isApp = location.pathname.startsWith('/application');

  if (isApp) {
    return <ApplicationPage />;
  }

  return (
    <>
      <TopBar />
      {isPpcLp && <PPCLpHeader />}
      {!isPpcLp && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ppc-lp" element={<PPCLandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
      </main>
      {isPpcLp ? <Footer /> : <MetaFooter />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <PopupProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/application/*" element={<ApplicationPage />} />
          <Route path="*" element={<Layout />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </PopupProvider>
    </BrowserRouter>
  );
}

export default App;
